export const countriesWithSpecialCharacterCities = ["DE"];
